<template>
  <div style="margin-top: 10px">
    <b-img center fluid-grow class="screenshot" :src="screenshotURL" />

    <div class="timestamp">
      <b-icon icon="arrow-clockwise" />{{ screenshotTimestamp }}
    </div>

    <template v-if="refreshBtn">
      <p-button
        @click="refresh"
        type="default"
        size="sm"
        outline
        class="float-right"
        :disabled="loader"
      >
        <b-icon icon="arrow-clockwise" /><span>{{ $t('button.refresh') }}</span>
      </p-button>

      <RequestInfo :ok="ok" :error="error" :loader="loader" />
    </template>
  </div>
</template>

<script>
import sseDisplay from '@/store/displays/sseDisplay'

export default {
  props: {
    item: { default: null },
    refreshBtn: { default: false },
  },

  data() {
    return {
      ok: false,
      error: false,
      loader: false,
      defaultImage: '/traveller-ui/static/traveller/img/not-found.png',
      screenshotUpdater: null,
      screenshotRequest: null,
    }
  },
  computed: {
    display() {
      return this.item
    },
    screenshots() {
      return this.$store.state.sseDisplay.screenshots
    },
    screenshotURL() {
      var screenshot = this.defaultImage
      if (this.display) {
        var iScreenshot = this.screenshots[this.display.uniqueId]
        if (iScreenshot && iScreenshot.base64) screenshot = iScreenshot.base64
      }
      return screenshot
    },
    screenshotTimestamp() {
      var timestamp = '-'
      if (this.display && this.screenshots[this.display.uniqueId]) {
        timestamp = this.screenshots[this.display.uniqueId].timestamp
      }
      return timestamp
    },
  },
  watch: {
    display() {
      this.ok = this.error = this.loader = false
      this.updateScreenshot()
    },
  },
  methods: {
    refresh() {
      this.ok = this.error = false
      this.loader = true
      const self = this
      this.$store.dispatch(
        'sseDisplay/sendCaptureRequest',
        this.display.deviceId
      )

      setTimeout(() => {
        self.ok = true
        self.loader = false
      }, 1000)
    },
    updateScreenshot() {
      clearTimeout(this.screenshotUpdater)
      if (this.display) {
        this.$store.dispatch('sseDisplay/getScreenshot', this.display.uniqueId)
      }
      this.screenshotUpdater = setTimeout(this.updateScreenshot, 5000)
    },
    requestScreenshot() {
      clearTimeout(this.screenshotRequest)
      if (this.display) {
        this.$store.dispatch(
          'sseDisplay/sendCaptureRequest',
          this.display.deviceId
        )
      }
      this.screenshotRequest = setTimeout(this.requestScreenshot, 30000)
    },
  },
  beforeCreate: function () {
    if (!this.$store.state.sseDisplay) {
      this.$store.registerModule('sseDisplay', sseDisplay)
    }
  },
  created() {
    this.requestScreenshot()
    this.updateScreenshot()
  },
  beforeDestroy() {
    clearTimeout(this.screenshotUpdater)
    clearTimeout(this.screenshotRequest)
  },
}
</script>

<style scoped lang="scss">
.screenshot {
  border: 1px solid #6c757d;
  border: 1px solid #dee2e6;
}
.timestamp {
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;

  border: 1px solid #6c757d;
  border: 1px solid #dee2e6;
  border-top: 0;
  padding: 4px 10px 2px 10px;
  margin-top: -1px;

  text-align: center;

  color: #000;

  display: inline-block;

  border-radius: 0 0 3px 3px;

  background-color: rgba(0, 0, 0, 0.05);
}

.timestamp svg {
  margin-right: 8px;
}
</style>
